<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.phone_button_templates.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <fieldset [disabled]="isSaving" data-automation="default-phone-button-template-data-table">
      <ziro-datatable
        [class]="'ziro-card'"
        [dataAutomation]="'default-phone-button-templates-data-table'"
        [uniqueRowIdentifier]="'id'"
        [columns]="columns"
        [rowDataSource]="rows"
        (rowFieldChanged)="onTemplateChange($event)"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.phone_button_templates.header.model_name'"
          [items]="uniqueModels"
          [matchFn]="isModelMatch"
          [dataAutomation]="'default-phone-button-templates-model-filter'"
          [tableId]="'default-phone-button-templates'"
        ></ziro-datatable-multi-select-filter>

        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.phone_button_templates.header.protocol'"
          [items]="uniqueProtocols"
          [matchFn]="isProtocolMatch"
          [dataAutomation]="'default-phone-button-templates-protocol-filter'"
          [tableId]="'default-phone-button-templates'"
        ></ziro-datatable-multi-select-filter>

        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.phone_button_templates.header.cucm_server'"
          [items]="uniqueServers"
          [matchFn]="isCucmServerMatch"
          [dataAutomation]="'default-phone-button-templates-cucm-server-filter'"
          [tableId]="'default-phone-button-templates'"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    </fieldset>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
